import axios from "axios";
import * as API from "app/constants/ApiConstants";
import * as APP from "app/constants/AppConstants";
import Logoutsession from "../../logout/logoutsession.js";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import refreshTokenApi from "../../refreshtoken/refreshtokenapi";

export function managejoblistAPI(data, res) {
  return new Promise((resolve, reject) => {
    axios
      .get(API.MANAGEJOBLIST_URL + "?jobid=" + data.jobid, {
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("bearer_token"),
        },
      })
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          }
        },
        (error) => {
          if (APP.LOGOUTERROR == error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response.data);
          }
        }
      );
  });
}

export function managejobSearchAPI(data, res) {
  return new Promise((resolve, reject) => {
    axios
      .post(API.MANAGEJOBSEARCH_URL, data, {
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("bearer_token"),
        },
      })
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          }
        },
        (error) => {
          if (APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response.data);
          }
        }
      );
  });
}
// Job Details
// export function managejobDetailsAPI(data, res) {
//     console.log("apidata",data)
//     return new Promise((resolve, reject) => {
//         axios.get(API.MANAGEJOBDETAILS_URL, + data.jobid,
//             {
//                 headers: {
//                     'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
//                 }
//             }
//         )
//             .then(response => {
//                 console.log("response", response)
//                 if (APP.SUCCESS == response.status) {
//                     resolve(response.data)
//                 }
//             },
//                 // (error) => {
//                 //     console.log("error", error.response)
//                 //     if (APP.LOGOUTERROR == error.response.status) {
//                 //         Logoutsession()
//                 //     }
//                 //     else if (APP.TOKENERROR == error.response.status) {
//                 //         Logoutsession()
//                 //     }
//                 //     else {
//                 //         reject(error.response.data)
//                 //     }
//                 // }
//             );
//     });
// }

export function managejobDetailsAPI(data, res) {
  return new Promise((resolve, reject) => {
    axios
      .get(API.MANAGEJOBDETAILS_URL + "?jobid=" + data.jobid, {
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("bearer_token"),
        },
      })
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          }
        },
        (error) => {
          if (APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response.data);
          }
        }
      );
  });
}

export function getJobStatusList(res) {
  return new Promise((resolve, reject) => {
    axios
      .get(API.UPLOADJOBSTATUS_URL, {
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("bearer_token"),
        },
      })
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          }
        },
        (error) => {
          if (APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response.data);
          }
        }
      );
  });
}

//Post job on Dice for pow-128 CODE START... Ayush
export function postJobOnDice(Data, res) {
  return new Promise((resolve, reject) => {
    axios
      .post(API.DICEJOBPOST_URL, Data, {
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("bearer_token"),
          "content-type": "text/plain",
        },
      })
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          }
        },
        (error) => {
          if (APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response.data);
          }
        }
      );
  });
}
//Post Job on Dice POW-128 Code Ends//

//get all dashboard Data Pow-99 starts//

export function getDashboardData(res) {
  return new Promise((resolve, reject) => {
    axios
      .get(API.GETALLDATA, {
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("bearer_token"),
        },
      })
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          }
        },
        (error) => {
          if (APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response.data);
          }
        }
      );
  });
}

//get all  dashboard Data Pow-99 ends//

//get all job Unattended POW_99 starts
export function getAllJobUnattended(data, res) {
  return new Promise((resolve, reject) => {
    axios
      .get(
        API.GETALLJOBUNATTENDED +
          "?startDate=" +
          data.startDate +
          "&endDate=" +
          data.endDate,
        {
          headers: {
            Authorization:
              "Bearer" + " " + localStorage.getItem("bearer_token"),
          },
        }
      )
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          }
        },
        (error) => {
          if (APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response.data);
          }
        }
      );
  });
}
//get all job Unattended POW_99 ends

/* Added the following code for POW-889.Dharma using AI Agent. July 20, 2026. Code Start */
export function getAllJobProcessedNotSubmitted(data, res) {
  return new Promise((resolve, reject) => {
    axios
      .get(
        API.GETALLJOBPROCESSEDNOTSUBMITTED +
          "?startDate=" +
          data.startDate +
          "&endDate=" +
          data.endDate,
        {
          headers: {
            Authorization:
              "Bearer" + " " + localStorage.getItem("bearer_token"),
          },
        }
      )
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          }
        },
        (error) => {
          if (APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response.data);
          }
        }
      );
  });
}
/* Code end. Dharma using AI Agent. July 20, 2026 */

/* Added the following code for POW-947.Harsha using AI Agent. October 5, 2026. Code Start */
export function getAllJobNotTouched(data, res) {
  return new Promise((resolve, reject) => {
    axios
      .get(
        API.GETALLJOBNOTTOUCHED +
          "?startDate=" +
          data.startDate +
          "&endDate=" +
          data.endDate,
        {
          headers: {
            Authorization:
              "Bearer" + " " + localStorage.getItem("bearer_token"),
          },
        }
      )
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          } else {
            res(response.data || { data: { allJobNotTouched: [] } });
          }
        },
        (error) => {
          if (APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response.data || { data: { allJobNotTouched: [] } });
          }
        }
      );
  });
}
/* Code end. Harsha using AI Agent. October 5, 2026 */

/* Added the following code for POW-891.Harsha using AI Agent. July 16, 2026. Code Start */
export function getCandidateRejections(data, res) {
  return new Promise((resolve, reject) => {
    axios
      .get(
        API.GETCANDIDATEREJECTIONS +
          "?startDate=" +
          data.startDate +
          "&endDate=" +
          data.endDate,
        {
          headers: {
            Authorization:
              "Bearer" + " " + localStorage.getItem("bearer_token"),
          },
        }
      )
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          }
        },
        (error) => {
          if (APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response.data);
          }
        }
      );
  });
}
/* Code end. Harsha using AI Agent. July 16, 2026 */

//get all job clients total POW_99 starts
export function getAllJobsClientsTotal(data, res) {
  return new Promise((resolve, reject) => {
    axios
      .get(
        API.GETALLJOBSCLIENTTOTALS +
          "?startDate=" +
          data.startDate +
          "&endDate=" +
          data.endDate,
        {
          headers: {
            Authorization:
              "Bearer" + " " + localStorage.getItem("bearer_token"),
          },
        }
      )
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          }
        },
        (error) => {
          if (APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response.data);
          }
        }
      );
  });
}

//get all job clients total POW_99 starts

//get Recruiter Submission POW_99 starts

export function getRecruiterSubmissions(data, res) {
  return new Promise((resolve, reject) => {
    axios
      .get(
        API.GETRECRUITERSUBMISSIONS +
          "?startDate=" +
          data.startDate +
          "&endDate=" +
          data.endDate,
        {
          headers: {
            Authorization:
              "Bearer" + " " + localStorage.getItem("bearer_token"),
          },
        }
      )
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          }
        },
        (error) => {
          if (APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response.data);
          }
        }
      );
  });
}

//get Recruiter Submission POW_99 ends

//get assigned recruiters jobs POW_99 starts

export function getAssignedRecruitersJobs(data, res) {
  return new Promise((resolve, reject) => {
    axios
      .get(
        API.ASSIGNEDRECRUITERSJOBS +
          "?startDate=" +
          data.startDate +
          "&endDate=" +
          data.endDate,
        {
          headers: {
            Authorization:
              "Bearer" + " " + localStorage.getItem("bearer_token"),
          },
        }
      )
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          }
        },
        (error) => {
          if (APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response.data);
          }
        }
      );
  });
}
//get assigned recruiters jobs POW_99 ends

/* Added this code for  POW-486. Dharmateja. February 24 2023.. Code Start */
export function manageCandidateStatusAPI(res) {
  return new Promise((resolve, reject) => {
      axios.get(API.MANAGECANDIDATESTATUS_URL,
          {
              headers: {
                  'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
              }
          }
      )
          .then(response => {
              if (APP.SUCCESS === response.status) {
                  res(response.data)
              }
          },
              (error) => {
                  if (APP.LOGOUTERROR === error.response.status) {
                      Logoutsession()
                      toast("Your session is timed out, not able to proceed further", {
                          position: toast.POSITION.TOP_CENTER,
                          className: 'foo-bar'
                      })
                  }
                  else if (APP.TOKENERROR === error.response.data.erroCode) {
                      refreshTokenApi(error.response.data.refreshToken, (resp) => {
                          localStorage.setItem('bearer_token', resp.token)
                          res(resp)
                      })
                  }
                  else {
                      res(error.response.data)
                  }
              }
          );
  });
}
/* Dharmateja. February 24 2023.. Code End */

/***** Added code for Task:POW-668   *(Dharma Teja - 16-07-2025) *****/
export function manageJobAssignAPI(data, res) {
  return new Promise((resolve, reject) => {
    axios
      .post(API.MANAGEJOBASSIGN_URL, data, {
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("bearer_token"),
        },
      })
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          }
        },
        (error) => {
          if (APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response.data);
          }
        }
      );
  });
}
/***** Completed code for Task:POW-668   *(Dharma Teja - 16-07-2025) *****/

// Check submit status API
export function checkSubmitStatusAPI(candid, res) {
  return new Promise((resolve, reject) => {
    axios
      .post(API.CHECK_SUBMIT_STATUS_URL + "?candid=" + candid, {}, {
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("bearer_token"),
        },
      })
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          }
        },
        (error) => {
          if (APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response.data);
          }
        }
      );
  });
}

/* Added the following code for POW-793.Dharma using AI Agent. February 27, 2026. Code Start */
/**
 * Calls the backend to validate whether a candidate's resume contains the required skills.
 * @param {number} candidateId - candidate DB id
 * @param {string} jobId - job id
 * @param {string} indexId - candidate index id (used to fetch resume)
 * @param {function} res - callback
 */
export function validateResumeSkillsAPI(candidateId, jobId, indexId, res) {
  return new Promise((resolve, reject) => {
    axios
      .post(
        API.VALIDATE_RESUME_SKILLS_URL +
          "?candidateId=" + candidateId +
          "&jobId=" + jobId +
          "&indexId=" + indexId,
        {},
        {
          headers: {
            Authorization: "Bearer" + " " + localStorage.getItem("bearer_token"),
          },
        }
      )
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          }
        },
        (error) => {
          if (APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response.data);
          }
        }
      );
  });
}
/* Code end. Dharma using AI Agent. February 27, 2026 */

/* Added the following code for POW-804.Solomon using AI Agent. June 24, 2026. Code Start */
/**
 * POW-804: Generates an AI-updated resume for local download (does not save to system).
 * POW-964: updateMode — INFERRED | MISSING | BOTH; additionalPrompt from Missing Skills Q&A.
 */
export function aiGenerateResumeAPI(candidateId, jobId, indexId, updateMode, additionalPrompt, res) {
  return new Promise((resolve, reject) => {
    /* Added the following code for POW-964.Harsha using AI Agent. October 21, 2026. Code Start */
    const mode = encodeURIComponent(updateMode || "BOTH");
    const requestBody = {
      additionalPrompt: additionalPrompt || "",
    };
    /* Code end. Harsha using AI Agent. October 21, 2026 */
    axios
      .post(
        API.AI_GENERATE_RESUME_URL +
          "?candidateId=" + candidateId +
          "&jobId=" + jobId +
          "&indexId=" + indexId +
          /* Added the following code for POW-964.Harsha using AI Agent. October 21, 2026. Code Start */
          "&updateMode=" + mode,
          /* Code end. Harsha using AI Agent. October 21, 2026 */
        requestBody,
        {
          headers: {
            Authorization: "Bearer" + " " + localStorage.getItem("bearer_token"),
          },
        }
      )
      .then(
        (response) => {
          if (response && response.data) {
            res(response.data);
          } else {
            res({
              statusCode: 500,
              message: "AI resume update failed — empty response from server.",
            });
          }
        },
        (error) => {
          if (error.response) {
            if (APP.LOGOUTERROR === error.response.status) {
              Logoutsession();
              toast("Your session is timed out, not able to proceed further", {
                position: toast.POSITION.TOP_CENTER,
                className: "foo-bar",
              });
              res({
                statusCode: 401,
                message: "Your session has timed out. Please log in again.",
              });
            } else if (
              error.response.data &&
              error.response.data.erroCode === APP.TOKENERROR
            ) {
              refreshTokenApi(error.response.data.refreshToken, (resp) => {
                localStorage.setItem("bearer_token", resp.token);
                res(resp);
              });
            } else {
              res(
                error.response.data || {
                  statusCode: error.response.status || 500,
                  message: "AI resume update request failed. Please try again.",
                }
              );
            }
          } else {
            res({
              statusCode: 500,
              message:
                "Network error while contacting the AI resume service. Check your connection and try again.",
            });
          }
        }
      );
  });
}
/* Code end. Solomon using AI Agent. June 24, 2026 */

// Save Candidate Note
export function saveCandidateNoteAPI(data, res) {
  return new Promise((resolve, reject) => {
    axios
      .post(API.SAVE_CANDIDATE_NOTE_URL, data, {
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("bearer_token"),
        },
      })
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          }
        },
        (error) => {
          if (APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response.data);
          }
        }
      );
  });
}

// Get Candidate Note
export function getCandidateNoteAPI(data, res) {
  return new Promise((resolve, reject) => {
    axios
      .get(API.GET_CANDIDATE_NOTE_URL + "?jobid=" + data.jobId + "&candid=" + data.candId, {
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("bearer_token"),
        },
      })
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          }
        },
        (error) => {
          if (APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response.data);
          }
        }
      );
  });
}

/* Added the following code for POW-864.Dharma using AI Agent. June 27, 2026. Code Start */
/* Added the following code for POW-885.Dharma using AI Agent. July 22, 2026. Code Start */
/** Returns true when axios response body is SPA HTML instead of JSON API payload */
function isHtmlApiResponse(response) {
  const contentType = (response.headers && (response.headers["content-type"] || response.headers["Content-Type"])) || "";
  if (contentType.includes("text/html")) {
    return true;
  }
  const data = response.data;
  return typeof data === "string" && data.trim().toLowerCase().startsWith("<!doctype html");
}
/* Code end. Dharma using AI Agent. July 22, 2026 */

export function getVitelglobalRecordingsAPI(data, res) {
  const requestUrl =
    API.VITELGLOBAL_RECORDINGS_URL + "?jobId=" + encodeURIComponent(data.jobId) + "&candId=" + encodeURIComponent(data.candId);
  return new Promise((resolve, reject) => {
    axios
      .get(requestUrl, {
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("bearer_token"),
        },
      })
      .then(
        (response) => {
          if (APP.SUCCESS === response.status && !isHtmlApiResponse(response)) {
            res(response.data);
          } else {
            res({ count: 0, recordings: [] });
          }
        },
        (error) => {
          if (error.response && APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (error.response && APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response ? error.response.data : { count: 0, recordings: [] });
          }
        }
      );
  });
}

export function fetchVitelglobalRecordingBlob(filename) {
  return axios
    .get(API.VITELGLOBAL_RECORDING_STREAM_URL + encodeURIComponent(filename), {
      headers: {
        Authorization: "Bearer" + " " + localStorage.getItem("bearer_token"),
      },
      responseType: "blob",
    })
    .then((response) => {
      const contentType = (response.headers && response.headers["content-type"]) || response.data.type || "";
      if (
        response.status !== 200 ||
        (contentType && !contentType.includes("audio") && !contentType.includes("octet-stream"))
      ) {
        return Promise.reject(new Error("Recording stream unavailable"));
      }
      return response;
    });
}
/* Code end. Dharma using AI Agent. June 27, 2026 */

/* Added the following code for POW-779.Dharma using AI Agent. February 28, 2026. Code Start */
export function saveJobNoteAPI(data, res) {
  return new Promise((resolve, reject) => {
    axios
      .post(API.SAVE_JOB_NOTE_URL, data, {
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("bearer_token"),
          /* Added the following code for POW-873.Dharma using AI Agent. June 18, 2026. Code Start */
          "Content-Type": "application/json",
          /* Code end. Dharma using AI Agent. June 18, 2026 */
        },
      })
      .then(
        (response) => {
          /* Added the following code for POW-873.Dharma using AI Agent. June 18, 2026. Code Start */
          if (response && response.data) {
            res(response.data);
          } else {
            res({ erroMessage: 'Unexpected response from server.', erroCode: 'FAILURE' });
          }
          /* Code end. Dharma using AI Agent. June 18, 2026 */
        },
        (error) => {
          /* Added the following code for POW-779.Dharma using AI Agent. February 28, 2026. Code Start */
          if (!error.response) {
            res({ error: 'Network error', message: 'Backend not reachable. Please try again.' });
            return;
          }
          /* Code end. Dharma using AI Agent. February 28, 2026 */
          if (APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (error.response.data && APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response.data || { erroMessage: 'Failed to save job note. Please try again.', erroCode: 'FAILURE' });
          }
        }
      );
  });
}

export function getJobNoteAPI(data, res) {
  return new Promise((resolve, reject) => {
    axios
      .get(API.GET_JOB_NOTE_URL + "?jobid=" + data.jobId, {
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("bearer_token"),
        },
      })
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          }
        },
        (error) => {
          /* Added the following code for POW-779.Dharma using AI Agent. February 28, 2026. Code Start */
          if (!error.response) {
            // Network error or backend not reachable - still call res so noteLoading is cleared
            res({ note: '', error: 'Network error' });
            return;
          }
          /* Code end. Dharma using AI Agent. February 28, 2026 */
          if (APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response.data);
          }
        }
      );
  });
}
/* Code end. Dharma using AI Agent. February 28, 2026 */

/* Added the following code for POW-869.Dharma using AI Agent. June 9, 2026. Code Start */
export function updateSubmissionDeadlineAPI(data, res) {
  return new Promise((resolve, reject) => {
    axios
      .post(API.UPDATE_SUBMISSION_DEADLINE_URL, data, {
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("bearer_token"),
        },
      })
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          }
        },
        (error) => {
          if (!error.response) {
            res({ error: "Network error", message: "Backend not reachable. Please try again." });
            return;
          }
          if (APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response.data);
          }
        }
      );
  });
}
/* Code end. Dharma using AI Agent. June 9, 2026 */

/* Added the following code for No Jira Ticket.Harsha using AI Agent. October 29, 2026. Code Start */
export function getSubmissionDeadlineAPI(clientJobId, res) {
  return new Promise((resolve, reject) => {
    axios
      .get(API.GET_SUBMISSION_DEADLINE_URL, {
        params: { clientJobId },
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("bearer_token"),
        },
      })
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          }
        },
        (error) => {
          if (!error.response) {
            res({ error: "Network error", message: "Backend not reachable. Please try again." });
            return;
          }
          if (APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (error.response.data && APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response.data || {});
          }
        }
      );
  });
}
/* Code end. Harsha using AI Agent. October 29, 2026 */

/* Added the following code for POW-885.Dharma using AI Agent. July 2, 2026. Code Start */
export function refreshVmsOtherSubmissionsAPI(data, res) {
  return new Promise((resolve, reject) => {
    axios
      .post(API.REFRESH_VMS_OTHER_SUBMISSIONS_URL, data, {
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("bearer_token"),
        },
      })
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          }
        },
        (error) => {
          if (!error.response) {
            res({ error: "Network error", message: "Backend not reachable. Please try again." });
            return;
          }
          if (APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (error.response.data && APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response.data);
          }
        }
      );
  });
}
/* Code end. Dharma using AI Agent. July 2, 2026 */

// Get Views
export function getViewsAPI(res) {
  return new Promise((resolve, reject) => {
    axios
      .get(API.GET_VIEWS_URL, {
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("bearer_token"),
        },
      })
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          }
        },
        (error) => {
          if (APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response.data);
          }
        }
      );
  });
}

/* Added the following code for POW-811.Harsha using AI Agent. May 19, 2026. Code Start */
export function hideCheckAPI(res) {
  return new Promise((resolve, reject) => {
    axios
      .get(API.HIDE_CHECK_URL, {
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("bearer_token"),
        },
      })
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          }
        },
        (error) => {
          if (APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else {
            res(error.response.data);
          }
        }
      );
  });
}

export function hideCandidateAPI(data, res) {
  return new Promise((resolve, reject) => {
    axios
      .post(API.HIDE_CANDIDATE_URL, data, {
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("bearer_token"),
        },
      })
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          }
        },
        (error) => {
          if (APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response.data);
          }
        }
      );
  });
}

export function hideJobAPI(data, res) {
  return new Promise((resolve, reject) => {
    axios
      .post(API.HIDE_JOB_URL, data, {
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("bearer_token"),
        },
      })
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          }
        },
        (error) => {
          if (APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response.data);
          }
        }
      );
  });
}
/* Code end. Harsha using AI Agent. May 19, 2026 */

// Get Candidates for a Job
/* Added the following code for POW-CLIENT-SUBMIT.Istiyak using AI Agent. June 5, 2026. Code Start */
/**
 * Starts a browser-based client submit session for the selected candidate and job.
 * @param {object} data - ClientSubmitRequest payload (jobId, clientJobId, candidateId)
 * @param {function} res - callback with { liveViewUrl, sessionId, status } or error
 */
export function clientSubmitAPI(data, res) {
  return new Promise((resolve, reject) => {
    axios
      .post(API.CLIENT_SUBMIT_URL, data, {
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("bearer_token"),
          "Content-Type": "application/json",
        },
      })
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          }
        },
        (error) => {
          if (error.response && APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (error.response && APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response ? error.response.data : { erroMessage: "Unable to start client submit session." });
          }
        }
      );
  });
}

/**
 * Records the outcome of a client submit session (ClientSubmitResult).
 * @param {object} data - { jobId, clientJobId, candidateId, result }
 * @param {function} res - callback
 */
export function clientSubmitStatusAPI(data, res) {
  return new Promise((resolve, reject) => {
    axios
      .post(API.CLIENT_SUBMIT_STATUS_URL, data, {
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("bearer_token"),
          "Content-Type": "application/json",
        },
      })
      .then(
        (response) => {
          if (APP.SUCCESS === response.status) {
            res(response.data);
          }
        },
        (error) => {
          if (error.response && APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (error.response && APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response ? error.response.data : { erroMessage: "Unable to update client submit status." });
          }
        }
      );
  });
}
/* Code end. Istiyak using AI Agent. June 5, 2026 */

export function getJobCandidatesAPI(jobId, res) {
  return new Promise((resolve, reject) => {
    axios
      .post(API.GET_JOB_CANDIDATES_URL + "?jobId=" + jobId, {}, {
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("bearer_token"),
        },
      })
      .then(
        (response) => {
          if (response && response.data) {
            res(response.data);
          }
        },
        (error) => {
          if (error.response && APP.LOGOUTERROR === error.response.status) {
            Logoutsession();
            toast("Your session is timed out, not able to proceed further", {
              position: toast.POSITION.TOP_CENTER,
              className: "foo-bar",
            });
          } else if (error.response && APP.TOKENERROR === error.response.data.erroCode) {
            refreshTokenApi(error.response.data.refreshToken, (resp) => {
              localStorage.setItem("bearer_token", resp.token);
              res(resp);
            });
          } else {
            res(error.response ? error.response.data : { erroMessage: "Unable to load candidates." });
          }
        }
      );
  });
}

/* Added the following code for Istiyak using AI Agent. August 21, 2026. Code Start */
/**
 * Dedupes identical NAVIGATED_* calls for the same path so layout remounts
 * do not write duplicate recruiter logs.
 */
let lastTrackedNavigationPath = "";

/**
 * Maps frontend routes to RecruiterAction NAVIGATED_TO_* values.
 * More specific paths are listed first so they win over shared prefixes.
 */
const RECRUITER_NAVIGATION_ACTIONS = [
  { path: "/recruiter/automationdashboard", action: API.RECRUITER_ACTIONS.NAVIGATED_TO_AUTOMATION_DASHBOARD },
  { path: "/recruiter/dashboard", action: API.RECRUITER_ACTIONS.NAVIGATED_TO_DASHBOARD },
  { path: "/analyticsdashboard", action: API.RECRUITER_ACTIONS.NAVIGATED_TO_DASHBOARD },
  { path: "/teamlead/dashboard", action: API.RECRUITER_ACTIONS.NAVIGATED_TO_DASHBOARD },
  { path: "/upload/uploadjobs", action: API.RECRUITER_ACTIONS.NAVIGATED_TO_UPLOAD_JOBS },
  { path: "/upload/managejob", action: API.RECRUITER_ACTIONS.NAVIGATED_TO_MANAGE_JOBS },
  { path: "/match/resume-job-match", action: API.RECRUITER_ACTIONS.NAVIGATED_TO_RESUME_JOB_MATCH },
  { path: "/upload/managecandidates", action: API.RECRUITER_ACTIONS.NAVIGATED_TO_MANAGE_CANDIDATES },
  { path: "/upload/manageconsultant", action: API.RECRUITER_ACTIONS.NAVIGATED_TO_MANAGE_CONSULTANTS },
  { path: "/upload/job-resume-match-history", action: API.RECRUITER_ACTIONS.NAVIGATED_TO_JOB_RESUME_MATCH_HISTORY },
  { path: "/upload/matchhistory", action: API.RECRUITER_ACTIONS.NAVIGATED_TO_MATCH_HISTORY },
  { path: "/upload/chatbothistory", action: API.RECRUITER_ACTIONS.NAVIGATED_TO_CHATBOT_HISTORY },
  { path: "/teamlead/manageclient", action: API.RECRUITER_ACTIONS.NAVIGATED_TO_MANAGE_CLIENTS },
  { path: "/teamlead/managevendor", action: API.RECRUITER_ACTIONS.NAVIGATED_TO_MANAGE_VENDORS },
  { path: "/teamlead/managerecruitersnetwork", action: API.RECRUITER_ACTIONS.NAVIGATED_TO_MANAGE_RECRUITERS_NETWORK }
];

/**
 * True when the current session is a recruiter/admin (not candidate portal).
 */
function canTrackRecruiterAction() {
  if (typeof localStorage === "undefined") {
    return false;
  }
  if (!localStorage.getItem("bearer_token") || !localStorage.getItem("UserName")) {
    return false;
  }
  return localStorage.getItem("userType") !== "candidate";
}

/**
 * Fire-and-forget POST /api/job/track/recruiter. Failures are swallowed so tracking
 * never blocks or surfaces UI errors.
 *
 * @param {Object} logRequest RecruiterLogRequest fields
 * @param {string} logRequest.action RecruiterAction enum name
 * @param {string} [logRequest.username]
 * @param {string} [logRequest.jobId]
 * @param {string} [logRequest.clientJobId]
 * @param {number|string} [logRequest.candid]
 * @param {boolean} [logRequest.autoPR] Ignored. /track/recruiter always sends autoPR false.
 * @param {string} [logRequest.metadata]
 */
export function trackRecruiterAction(logRequest) {
  if (!logRequest || !logRequest.action || !canTrackRecruiterAction()) {
    /* Added the following code for Istiyak using AI Agent. September 17, 2026. Code Start */
    return Promise.resolve();
    /* Commenting the following code for Istiyak using AI Agent. September 17, 2026. Comment Start */
    /* return; */
    /* Commenting end. Istiyak using AI Agent. September 17, 2026 */
    /* Code end. Istiyak using AI Agent. September 17, 2026 */
  }
  /* Added the following code for Istiyak using AI Agent. September 17, 2026. Code Start */
  if (logRequest.action === API.RECRUITER_ACTIONS.LOGIN) {
    return Promise.resolve();
  }
  /* Code end. Istiyak using AI Agent. September 17, 2026 */

  const payload = {
    username: logRequest.username || localStorage.getItem("UserName") || "",
    action: logRequest.action,
    candid: Number(logRequest.candid) || 0,
    /* Added the following code for Istiyak using AI Agent. September 17, 2026. Code Start */
    autoPR: false,
    /* Commenting the following code for Istiyak using AI Agent. September 17, 2026. Comment Start */
    /* autoPR: logRequest.action === API.RECRUITER_ACTIONS.VIEW_EXPLANATION
      ? false
      : Boolean(logRequest.autoPR), */
    /* autoPR: Boolean(logRequest.autoPR), */
    /* Commenting end. Istiyak using AI Agent. September 17, 2026 */
    /* Code end. Istiyak using AI Agent. September 17, 2026 */
    metadata: logRequest.metadata || ""
  };
  const trackedJobId = logRequest.jobId != null ? String(logRequest.jobId).trim() : "";
  const trackedClientJobId = logRequest.clientJobId != null ? String(logRequest.clientJobId).trim() : "";
  if (trackedJobId) {
    payload.jobId = trackedJobId;
  }
  if (trackedClientJobId) {
    payload.clientJobId = trackedClientJobId;
  }

  /* Commenting the following code for Istiyak using AI Agent. September 17, 2026. Comment Start */
  /*
  if (options && options.keepalive && typeof fetch === "function") {
    return fetch(API.TRACK_RECRUITER_URL, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("bearer_token"),
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload),
      keepalive: true
    }).catch(function () {
      // Silent by design: recruiter tracking must not affect the UI.
    });
  }
  */
  /* Commenting end. Istiyak using AI Agent. September 17, 2026 */

  /* Added the following code for Istiyak using AI Agent. September 17, 2026. Code Start */
  return axios.post(API.TRACK_RECRUITER_URL, payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("bearer_token"),
      "Content-Type": "application/json"
    }
  }).catch(function () {
    // Silent by design: recruiter tracking must not affect the UI.
  });
  /* Commenting the following code for Istiyak using AI Agent. September 17, 2026. Comment Start */
  /*
  axios.post(API.TRACK_RECRUITER_URL, payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("bearer_token"),
      "Content-Type": "application/json"
    }
  }).catch(function () {
    // Silent by design: recruiter tracking must not affect the UI.
  });
  */
  /* Commenting end. Istiyak using AI Agent. September 17, 2026 */
  /* Code end. Istiyak using AI Agent. September 17, 2026 */
}

/* Added the following code for Istiyak using AI Agent. August 25, 2026. Code Start */
/**
 * Recruiter Performance counts SUBMIT_IMMEDIATELY separately from VIEW_EXPLANATION.
 * Opening an explanation for a SUBMIT_IMMEDIATELY candidate must use that action.
 */
export function getExplanationTrackAction(recommendation) {
  const value = String(recommendation || "").toUpperCase();
  if (value.indexOf("SUBMIT_IMMEDIATELY") !== -1) {
    return API.RECRUITER_ACTIONS.SUBMIT_IMMEDIATELY;
  }
  return API.RECRUITER_ACTIONS.VIEW_EXPLANATION;
}
/* Code end. Istiyak using AI Agent. August 25, 2026 */

/**
 * Resolves the current pathname to a NAVIGATED_TO_* action and logs it once
 * per distinct path.
 *
 * @param {string} pathname React Router location.pathname
 */
export function trackRecruiterPageNavigation(pathname) {
  if (!pathname || pathname === lastTrackedNavigationPath || !canTrackRecruiterAction()) {
    return;
  }

  const match = RECRUITER_NAVIGATION_ACTIONS.find(function (entry) {
    return pathname === entry.path || pathname.indexOf(entry.path + "/") === 0;
  });
  if (!match) {
    return;
  }

  lastTrackedNavigationPath = pathname;
  trackRecruiterAction({
    action: match.action,
    metadata: JSON.stringify({ path: pathname })
  });
}
/* Code end. Istiyak using AI Agent. August 21, 2026 */